<template>
  <FlotoModule>
    <template v-if="hasPermission">
      <RouterView :key="$route.fullPath" />
    </template>
  </FlotoModule>
</template>

<script>
import { LicenseComputed } from '@state/modules/license'
import { authComputed } from '@state/modules/auth'
export default {
  name: 'DashboardModule',
  page() {
    return {
      title: this.$tc('dashboard'),
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
        to.name === 'dashboard.edit' &&
        (vm.availableModulesInLicense || []).indexOf('customDashboard') === -1
      ) {
        vm.$router.replace({ name: '404' })
        return
      }
      vm.hasPermission = true
    })
  },
  data() {
    return {
      hasPermission: false,
    }
  },
  computed: {
    ...LicenseComputed,
    ...authComputed,
  },
  created() {
    if (this.user.cxoUser) {
      if ((this.user.roleNames || []).indexOf('Dashboard Viewer') === -1) {
        if ((this.user.roleNames || []).indexOf('Report Viewer') >= 0) {
          const route = this.$router.resolve(
            this.$modules.getModuleRoute('reports')
          )
          window.location.href = route.href
        }
      }
    }
  },
}
</script>
